"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var base_1 = require("@bhtp-client-api/base");
var rxjs_1 = require("rxjs");
var countryCacheKey = 'countries';
var BhtpCountryService = (function (_super) {
    __extends(BhtpCountryService, _super);
    function BhtpCountryService(http, cacheRepo) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.cacheRepo = cacheRepo;
        return _this;
    }
    BhtpCountryService.prototype.getAllCountries = function () {
        var _this = this;
        var countries = null;
        try {
            countries = this.cacheRepo.getValueOfType(countryCacheKey);
        }
        catch (e) { }
        return rxjs_1.Observable.create(function (observer) {
            if (!countries) {
                var url = _this.getFullUrl("/Country");
                var options = _this.getStandardRequestOptions();
                _this.http.get(url, options)
                    .map(function (res) { return res.json(); })
                    .catch(_this.handleError)
                    .subscribe(function (countries) {
                    if (countries) {
                        observer.next(countries);
                        _this.cacheRepo.storeValueOfType(countryCacheKey, countries);
                    }
                }, function (error) {
                    observer.error(error);
                }, function () {
                    observer.complete();
                });
            }
            else {
                observer.next(countries);
                observer.complete();
            }
        });
    };
    BhtpCountryService.prototype.getCountryByIsoCode2 = function (countryIsoCode2) {
        var _this = this;
        return rxjs_1.Observable.create(function (observer) {
            _this.getAllCountries()
                .subscribe(function (countries) {
                var countryNotFound = new Error("Country for Iso Code " + countryIsoCode2 + " not found");
                if (countries && countryIsoCode2) {
                    var country = countries.find(function (country) { return country.isoCode2 === countryIsoCode2; });
                    if (country) {
                        observer.next(country);
                    }
                    else {
                        observer.error(countryNotFound);
                    }
                }
                else {
                    observer.error(countryNotFound);
                }
            }, function (error) {
                observer.error(error);
            }, function () {
                observer.complete();
            });
        });
    };
    return BhtpCountryService;
}(base_1.BhtpBaseService));
BhtpCountryService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, Object])
], BhtpCountryService);
exports.BhtpCountryService = BhtpCountryService;
//# sourceMappingURL=D:/a/1/s/eligibility/src/country.service.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/eligibility/src/country.service.js